import { render, staticRenderFns } from "./selected-rows-field.vue?vue&type=template&id=00b143c6&scoped=true"
import script from "./selected-rows-field.vue?vue&type=script&lang=ts"
export * from "./selected-rows-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b143c6",
  null
  
)

export default component.exports